import './styles.css';

export default function Modal({
  children,
  className = ''
}) {
  return (
    <div className={`onboarding-modal ${className}`}>
      {children}
    </div>
  )
};